import script from "./NotificationCreateDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationCreateDialog.vue?vue&type=script&setup=true&lang=js"

import "./NotificationCreateDialog.vue?vue&type=style&index=0&id=6c5a3d17&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c5a3d17"]])

export default __exports__